import { FC } from "react";
import { IconPropsType } from ".";

export const Message: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6665 7.00008C4.6665 6.81599 4.81574 6.66675 4.99984 6.66675L10.9998 6.66675C11.1839 6.66675 11.3332 6.81599 11.3332 7.00008C11.3332 7.18418 11.1839 7.33341 10.9998 7.33341L4.99984 7.33341C4.81574 7.33341 4.6665 7.18418 4.6665 7.00008Z"
        fill={props.color}
      />
      <path
        d="M5.3335 9.66659C5.3335 9.48249 5.48273 9.33325 5.66683 9.33325H10.3335C10.5176 9.33325 10.6668 9.48249 10.6668 9.66659C10.6668 9.85068 10.5176 9.99992 10.3335 9.99992H5.66683C5.48274 9.99992 5.3335 9.85068 5.3335 9.66659Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.6H6C3.01766 0.6 0.6 3.01766 0.6 6V10C0.6 12.9823 3.01766 15.4 6 15.4H15.4V6C15.4 3.01766 12.9823 0.6 10 0.6ZM6 0C2.68629 0 0 2.68629 0 6V10C0 13.3137 2.68629 16 6 16H16V6C16 2.68629 13.3137 0 10 0H6Z"
        fill={props.color}
      />
    </svg>
  );
};
